import { useEffect, forwardRef, useImperativeHandle } from 'react';
import fabric from '@/pages/customize/utils/newFabric';

// import { fabric } from 'fabric';
import './index.scss';

let zoomCanvas = null;

let point = null;
const marginNum = 40; // 距离边缘的距离
let showTimer = null;
const Magnifier = forwardRef((props: any, ref: any) => {
  const { canvasIns, isZoom, cir } = props;
  useEffect(() => {
    if (isZoom) {
      let obj = JSON.stringify(canvasIns);
      zoomCanvas.loadFromJSON(obj);
    }
  }, [props.isZoom]);
  useEffect(() => {
    zoomCanvas = new fabric.Canvas('edit_magnifier', {
      controlsAboveOverlay: true,
      enableRetinaScaling: true,
      selection: false
    });
    zoomCanvas.setWidth(390);
    zoomCanvas.setHeight(780);
    zoomCanvas.freeDrawingBrush = new fabric.EraserBrush(zoomCanvas);
    zoomCanvas.freeDrawingBrush.width = cir * 4;
  }, []);
  useEffect(() => {
    zoomCanvas.freeDrawingBrush.width = cir * 4;
    let obj: HTMLElement = document.querySelector('.zoom-brush-cir');
    obj.style.width = `${cir * 4}px`;
    obj.style.height = `${cir * 4}px`;
  }, [props.cir]);
  useImperativeHandle(ref, () => ({
    init() {
      zoomCanvas = new fabric.Canvas('edit_magnifier', {
        controlsAboveOverlay: true,
        enableRetinaScaling: true,
        selection: false
      });
      zoomCanvas.setWidth(390);
      zoomCanvas.setHeight(780);
      zoomCanvas.freeDrawingBrush = new fabric.EraserBrush(zoomCanvas);
      zoomCanvas.freeDrawingBrush.width = cir * 4;
    },
    dispose() {
      zoomCanvas.dispose();
    },
    updateImage() {
      let obj = JSON.stringify(canvasIns.toJSON(['name']));
      zoomCanvas.loadFromJSON(obj, () => {
        zoomCanvas.getObjects()[1].set({ erasable: true });
        zoomCanvas.remove(zoomCanvas.getObjects()[0]);
      });
    },
    down(options) {
      let con = document.querySelector('.edit-magnifier') as HTMLElement;
      if (con.style.display === 'block') {
        clearTimeout(showTimer);
      }
      con.style.display = 'block';
      let obj: HTMLElement = document.querySelector('.zoom-brush-cir');
      if (obj.style.display === 'none') {
        obj.style.display = 'block';
      }
      obj.style.top = `${
        Math.ceil(options.pointer.y) - canvasIns.freeDrawingBrush.width / 2 - 5
      }px`;
      obj.style.left = `${
        Math.ceil(options.pointer.x) - canvasIns.freeDrawingBrush.width / 2 - 5
      }px`;
      zoomCanvas.isDrawingMode = true;
      options.e.isPrimary = true;
      const pointer = canvasIns.getPointer(options.e);
      zoomCanvas.freeDrawingBrush.onMouseDown(pointer, options);
      let delta = new fabric.Point(-(pointer.x - marginNum), -(pointer.y - marginNum));
      (document.querySelector('.container-main') as HTMLElement).style.left = `${delta.x}px`;
      (document.querySelector('.container-main') as HTMLElement).style.top = `${delta.y}px`;
      point = pointer;
    },
    move(options) {
      let obj: HTMLElement = document.querySelector('.zoom-brush-cir');
      if (obj.style.display === 'block') {
        obj.style.top = `${
          Math.ceil(options.pointer.y) - canvasIns.freeDrawingBrush.width / 2 - 5
        }px`;
        obj.style.left = `${
          Math.ceil(options.pointer.x) - canvasIns.freeDrawingBrush.width / 2 - 5
        }px`;
      }
      options.e.isPrimary = true;
      const pointer = canvasIns.getPointer(options.e);
      zoomCanvas.freeDrawingBrush.onMouseMove(pointer, options);
      let delta = new fabric.Point(-(pointer.x - marginNum), -(pointer.y - marginNum));
      (document.querySelector('.container-main') as HTMLElement).style.left = `${delta.x}px`;
      (document.querySelector('.container-main') as HTMLElement).style.top = `${delta.y}px`;
      point = pointer;
    },
    mouseUp(options) {
      let obj: HTMLElement = document.querySelector('.zoom-brush-cir');
      obj.style.display = 'none';

      showTimer = setTimeout(() => {
        let obj: HTMLElement = document.querySelector('.edit-magnifier');
        if (obj.style.display === 'block') {
          obj.style.display = 'none';
        }
      }, 1000);
      zoomCanvas.isDrawingMode = false;
      options.e.isPrimary = true;
      zoomCanvas.freeDrawingBrush.onMouseUp(options);
    }
  }));
  return (
    <div className='edit-magnifier'>
      <div className='container-main'>
        <div
          className='zoom-brush-cir'
          style={{
            display: 'none',
            width: '16px',
            height: '16px',
            top: '100px',
            left: '100px'
          }}
        ></div>
        <canvas id='edit_magnifier'></canvas>
      </div>
    </div>
  );
});

export default Magnifier;
